module.exports = __webpack_public_path__ + "img/speaker2.9e17508a.png";